var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDanger = function SvgDanger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32065 2.38513C7.26141 0.704955 9.61371 0.704955 10.5537 2.38513L16.5444 13.0946C17.4843 14.7748 16.3082 16.875 14.4275 16.875H2.44684C0.566137 16.875 -0.6092 14.7748 0.330744 13.0946L6.31983 2.38513H6.32065ZM8.43756 6.79308C8.59958 6.79308 8.75495 6.85947 8.86952 6.97763C8.98408 7.09579 9.04844 7.25605 9.04844 7.42315V10.5735C9.04844 10.7406 8.98408 10.9009 8.86952 11.019C8.75495 11.1372 8.59958 11.2036 8.43756 11.2036C8.27554 11.2036 8.12016 11.1372 8.0056 11.019C7.89104 10.9009 7.82668 10.7406 7.82668 10.5735V7.42315C7.82668 7.25605 7.89104 7.09579 8.0056 6.97763C8.12016 6.85947 8.27554 6.79308 8.43756 6.79308ZM8.43756 13.7238C8.59958 13.7238 8.75495 13.6574 8.86952 13.5393C8.98408 13.4211 9.04844 13.2609 9.04844 13.0938C9.04844 12.9267 8.98408 12.7664 8.86952 12.6482C8.75495 12.5301 8.59958 12.4637 8.43756 12.4637C8.27554 12.4637 8.12016 12.5301 8.0056 12.6482C7.89104 12.7664 7.82668 12.9267 7.82668 13.0938C7.82668 13.2609 7.89104 13.4211 8.0056 13.5393C8.12016 13.6574 8.27554 13.7238 8.43756 13.7238Z",
    fill: "current",
    stroke: "none"
  })));
};
export default __webpack_public_path__ + "assets/d6a07f9cae23f06d8a952207d55c5e2e.svg";
export { SvgDanger as ReactComponent };


// WEBPACK FOOTER //
// ./assets/icons/danger.svg